import React, { useState, useEffect } from 'react';
import DocumentCanvas from '../editor/DocumentCanvas';
import EscalaDocumento from '../editor/EscalaDocumento';
import { ORCAMENTO_DESIGN as D } from './Orcamento.design';

// Reserva para topbar, legenda, totais e botões da coluna lateral: o que sobrar
// da altura da janela é o teto da miniatura, para tudo caber sem rolar.
const alturaDisponivel = () => Math.max(280, window.innerHeight - 400);

// Miniatura viva do orçamento. O documento é o mesmo componente de leitura do
// editor completo: a prévia é o que o cliente recebe, não uma segunda
// interpretação. O tamanho real abre no VisualizadorDocumento.
export default function OrcamentoMiniatura({ proposta }) {
  const [maxHeight, setMaxHeight] = useState(alturaDisponivel);

  useEffect(() => {
    const atualizar = () => setMaxHeight(alturaDisponivel());
    window.addEventListener('resize', atualizar);
    return () => window.removeEventListener('resize', atualizar);
  }, []);

  return (
    <div className={D.mini}>
      <EscalaDocumento maxHeight={maxHeight}>
        <div className="pointer-events-none select-none">
          <DocumentCanvas proposta={proposta} onChange={() => {}} readOnly isModelo={false} />
        </div>
      </EscalaDocumento>
    </div>
  );
}
